import React from 'react'
import VLAuthentication from '@viewlift/web-authentication'
import { TVEDeviceConfig } from './TVEDeviceConfig'
import '@viewlift/web-authentication/dist/assets/style.css'
import './ActivateTveDevice.css'
import { BrandName } from '../../Typescript'

const ActivateTveDevice = ({ brandName }: { brandName: BrandName }) => {
    const { ActivateTveDevice } = VLAuthentication()
    const config = new TVEDeviceConfig().getConfig()
    const ConfiguredActivateDevice = ActivateTveDevice as unknown as React.FC<{ config: unknown }>
    if (brandName === BrandName.msnbc) {
        config.mediaInfo.tveBannerUrl =
            'https://lightning-dev.msnbc.com/tizen/develop/static/msnbc/splash_fhd.png'
    }
    return (
        <div id="activateTVEContainer">
            <ConfiguredActivateDevice config={config} />
        </div>
    )
}

export default ActivateTveDevice
